import type React from "react";
import {Button, Stack, Typography} from "@mui/material";
import {COLORS} from "~/style/colors-ts";
import {ACTION_BAR_HEIGHT} from "~/pages/taxonomy-builder-v2/constants/taxonomyBuilderLayout";

type ApprovalReviewActionBarProps = {
    /** Reverted changes so far, for the status on the left */
    revertedCount: number;
    disabled: boolean;
    onReject: () => void;
    onApprove: () => void;
};

/** Stuck to the bottom of the page, like the builder's action bar: finish the review. */
export const ApprovalReviewActionBar: React.FC<ApprovalReviewActionBarProps> = ({
                                                                                    revertedCount,
                                                                                    disabled,
                                                                                    onReject,
                                                                                    onApprove,
                                                                                }) => (
    <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        sx={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            height: ACTION_BAR_HEIGHT,
            px: 3,
            borderTop: `1px solid ${COLORS.grey[200]}`,
            backgroundColor: COLORS.white[900],
        }}
    >
        <Typography variant="caption" color="text.secondary" noWrap minWidth={0}>
            {revertedCount === 0
                ? 'Revert the changes you don\'t accept, then approve the rest or reject the request.'
                : `${revertedCount} ${revertedCount === 1 ? 'change' : 'changes'} reverted. Approving applies the rest.`}
        </Typography>
        <Stack direction="row" gap={1} sx={{flexShrink: 0}}>
            <Button variant="outlined" color="error" onClick={onReject} disabled={disabled}>Reject</Button>
            <Button variant="contained" onClick={onApprove} disabled={disabled}>Approve</Button>
        </Stack>
    </Stack>
);
